<template>
  <AbstractTaskModalComponent
    :disable-assignee="disableAssignee"
    :disable-date="true"
    :task="action"
    :event="event"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <template #description>
      <slot name="description" />
    </template>
    <slot />
  </AbstractTaskModalComponent>
</template>

<script lang="ts">
import { defineComponent, type PropType, computed } from "vue";
import { DateTime } from "luxon";
import { IdeaVeto, type EventListEventFieldsFragment } from "@/graphql";
import AbstractTaskModalComponent from "@/components/event-action/task/modal/AbstractTaskModalComponent.vue";
import type { EditTaskType } from "@/components/event-action/task/helper/DefaultTask";
import type { EventEditType } from "@/components/event-action/event/modal/EventEditType";

export default defineComponent({
  name: "AbstractIdeaTaskModalComponent",
  components: { AbstractTaskModalComponent },
  props: {
    action: {
      type: Object as PropType<EditTaskType>,
      required: true,
    },
    event: {
      type: Object as PropType<EventListEventFieldsFragment | EventEditType>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const disableAssignee = computed(
      () =>
        (props.action.meta?.__typename === "IdeaIdeaTaskMeta" &&
          props.action.meta.veto === IdeaVeto.veto) ||
        DateTime.fromISO(props.action.deadline ?? "") < DateTime.now().startOf("day"),
    );

    return {
      disableAssignee,
      IdeaVeto,
    };
  },
});
</script>

<style lang="scss" scoped></style>
